import { render, staticRenderFns } from "./PricePerYear.vue?vue&type=template&id=1510fe02"
import script from "./PricePerYear.vue?vue&type=script&lang=js"
export * from "./PricePerYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports